import CourseCard from './CourseCard';

export default CourseCard;
